import { computed, toValue, type ComputedRef, type MaybeRefOrGetter } from 'vue';

import type { CityTagsAdvanced } from '@/shared/models/types';
import { type GeoParams, useSeoStore } from '@/shared/store/seo';

type Sight = MaybeRefOrGetter<Pick<CityTagsAdvanced, 'id' | 'name'>>;
type WithSight = GeoParams & { tag_id: number; tag_name: string };

export function useSightAnalyticsParams(sight: Sight): ComputedRef<WithSight>;
export function useSightAnalyticsParams(): ComputedRef<GeoParams>;
export function useSightAnalyticsParams(sight?: Sight): ComputedRef<WithSight | GeoParams> {
  const seoStore = useSeoStore();

  return computed(() => ({
    ...seoStore.geo,
    ...(sight && { tag_id: toValue(sight).id, tag_name: toValue(sight).name }),
  }));
}
